<template>
  <v-container class="formulario-wrapper" fluid>
    <v-card class="elevation-2">

      <v-card-actions class="pa-4">
        <v-row>
          <v-col cols="4" class="text-left">
            <v-btn v-if="itemDexieId" color="error" outlined @click="excluir">Excluir</v-btn>
          </v-col>
          <v-col cols="4" class="text-center"> 
            <v-btn text @click="cancelar">Cancelar</v-btn>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn color="primary" @click="salvar">Salvar</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      
      <v-divider></v-divider>
      
      <v-card-text>
        <v-form ref="form">
          
          <v-row>
            <v-col cols="3">
              <v-text-field
                :value="item.codigoProduto || item.idCorTamanhoFinal"
                label="Código Produto"
                outlined
                dense
                hide-details
                readonly
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="item.nomeProduto"
                label="Nome Produto"
                outlined
                dense
                hide-details
                readonly
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-text-field v-model="item.marca" label="Marca" outlined dense hide-details readonly background-color="#FFF9C4"></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-text-field v-model="item.unidade" label="Unidade" outlined dense hide-details readonly background-color="#FFF9C4"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>

          <v-row v-if="isItemInativo">
            <v-col cols="12">
              <v-alert
                dense
                type="error"
                border="left"
                colored-border
                class="mb-0 caption font-weight-medium"
              >
                Não é possível salvar o item porque está inativo.
              </v-alert>
            </v-col>
          </v-row>

          <v-row v-if="textoPromocao">
            <v-col cols="12">
              <v-alert
                dense
                border="left"
                color="primary"
                colored-border
                
                class="mb-0 caption font-weight-medium"
              >
                {{ textoPromocao }}
              </v-alert>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" md="6">
              <v-text-field 
                ref="quantidadeInput"
                v-model.number="item.quantidade" 
                label="Quantidade" 
                type="number" 
                outlined dense hide-details
                :readonly="isBloqueado"
                @change="aoAlterarQuantidade"
                @keydown.enter.prevent="focarProximo('precoInput')"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-text-field 
                ref="precoInput"
                v-model="precoFormatado" 
                label="Preço" 
                type="tel" 
                outlined dense hide-details
                :readonly="isBloqueado"
                :background-color="(isBloqueado) ? '#FFF9C4' : ''"
                @keydown.enter.prevent="focarProximo('descPercentInput')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="1" class="">
              <v-btn fab x-small dark color="primary" @click="quantidadeEstoqueVisivel = !quantidadeEstoqueVisivel">
                <v-icon>{{ quantidadeEstoqueVisivel ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5" class="pb-0 pt-0">
              <v-text-field 
                class="pl-1"
                :value="quantidadeEstoqueVisivel ? quantidadeEstoqueFormatada : '-----'" 
                label="Estoque" 
                type="text" 
                outlined dense hide-details 
                readonly 
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>

            <v-col cols="1" class="pr-0">
              <v-btn fab x-small dark color="primary" @click="precoMinimoVisivel = !precoMinimoVisivel">
                <v-icon>{{ precoMinimoVisivel ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5" class="pb-0 pt-0">
              <v-text-field 
                class="pl-1"
                :value="precoMinimoVisivel ? precoMinimoFormatado : '-----'" 
                label="Preço Mínimo" 
                type="text" 
                outlined dense hide-details 
                readonly 
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row align="center">
            <v-col cols="1" class="">
              <v-btn fab x-small dark color="primary" @click="precoUltimaVendaVisivel = !precoUltimaVendaVisivel">
                <v-icon>{{ precoUltimaVendaVisivel ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="5" class="pb-0 pt-0">
              <v-text-field 
                class="pl-1"
                :value="precoUltimaVendaVisivel ? precoUltimaVendaFormatado : '-----'" 
                label="Última Venda" 
                type="text" 
                outlined dense hide-details 
                readonly 
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" md="6">
              <v-text-field 
                ref="descPercentInput"
                v-model="descontoPercentFormatado" 
                label="Desconto %" 
                suffix="%" 
                type="tel" 
                outlined dense hide-details
                :readonly="isBloqueado"
                :background-color="(isBloqueado) ? '#FFF9C4' : ''"
                @keydown.enter.prevent="focarProximo('descValorInput')"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-text-field 
                ref="descValorInput"
                v-model="descontoValorFormatado" 
                label="Desconto R$" 
                type="tel" 
                outlined dense hide-details
                :readonly="isBloqueado"
                :background-color="(isBloqueado) ? '#FFF9C4' : ''"
                @keydown.enter.prevent="focarProximo('obsInput')"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>

          <v-row>
            <v-col cols="6" md="6">
              <v-text-field 
                v-model="precoLiquido" 
                label="Líquido" 
                outlined dense hide-details 
                readonly 
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
            <v-col cols="6" md="6">
              <v-text-field 
                v-model="totalItem" 
                label="Total" 
                outlined dense hide-details 
                readonly 
                background-color="#FFF9C4"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-3"></v-divider>

          <v-row>
            <v-col cols="12" class="py-1" v-if="exibirDiluicao">
              <div class="text-caption grey--text text--darken-1 mb-1 mt-2">Proporção de Diluição</div>
              <v-row align="center">
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="item.textoDiluicao"
                    label="Diluição do Produto"
                    placeholder="Ex: 1/10"
                    outlined
                    dense
                    hide-details
                    :readonly="isBloqueado"
                    :background-color="isBloqueado ? '#FFF9C4' : ''"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field
                  v-model="valorDiluidoFormatado"
                  label="Valor do Produto Diluído"
                  outlined
                  dense
                  hide-details
                  type="tel"
                  :readonly="isBloqueado"
                  :background-color="item.atendido === 1 ? '#FFF9C4' : ''"
                ></v-text-field>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="py-1" v-if="exibirSubstituicao">
              <v-text-field
                v-model="item.textoSubstituicao"
                label="Produtos que podem ser substituídos"
                outlined
                dense
                hide-details
                class="mt-3"
                :readonly="isBloqueado"
                :background-color="item.atendido === 1 ? '#FFF9C4' : ''"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-textarea 
                v-model="item.observacao" 
                label="Observação" 
                outlined hide-details 
                rows="3"
                class="mt-4"
                :readonly="isBloqueado"
              ></v-textarea>
            </v-col>
          </v-row>

        </v-form>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogCancelar" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmar Cancelamento
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          Deseja realmente sair sem salvar as alterações?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogCancelar = false">Não</v-btn>
          <v-btn color="white" class="primary" text @click="confirmarCancelamento">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogExcluir" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Confirmar Exclusão
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          Deseja realmente excluir este item do pedido?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="dialogExcluir = false">Não</v-btn>
          <v-btn color="white" class="primary" text @click="confirmarExclusao">Sim, Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogValidacao" max-width="400">
      <v-card>
        <v-card-title class="headline primary white--text text--darken-2">
          Atenção
        </v-card-title>
        
        <v-card-text class="pt-4 body-1 black--text">
          Verifique os seguintes itens antes de salvar:
          <ul class="mt-3 ml-2">
            <li v-for="(msg, index) in mensagensErro" :key="index" class="red--text text--darken-3">
              {{ msg }}
            </li>
          </ul>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="dialogValidacao = false">
            Entendi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Confirmação de Estoque Insuficiente -->
    <v-dialog v-model="dialogConfirmacaoEstoque" persistent max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Atenção
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          <span v-if="parseFloat(item.estoque) <= 0">
            O produto está com o estoque zerado. Deseja realmente continuar?
          </span>
          <span v-else>
            A quantidade informada (<strong>{{ item.quantidade }}</strong>) é maior que o estoque disponível (<strong>{{ quantidadeEstoqueFormatada }}</strong>). Deseja realmente continuar?
          </span>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="black" text @click="cancelarConfirmacaoEstoque">Não</v-btn>
          <v-btn color="white" class="primary" text @click="confirmarEstoque">Sim</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog de Bloqueio de Estoque Insuficiente -->
    <v-dialog v-model="dialogBloqueioEstoque" max-width="450">
      <v-card>
        <v-card-title class="headline primary white--text">
          Estoque Insuficiente
        </v-card-title>
        <v-card-text class="pt-4 pb-0 text-body-1 black--text">
          {{ mensagemBloqueioEstoque }}
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="white" class="primary" text @click="fecharDialogBloqueio">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import db from '@/plugins/dexie';
// import SnackbarEvent from '@/events/SnackbarEvent';

export default {
  name: 'ViewCadastroPedidoItem',
  
  data() {
    return {
      produtoSelecionado: null,
      produtosEncontrados: [],
      searchCodigo: "",
      searchNome: "",
      loadingBusca: false,
      timerBusca: null, 

      itemDexieId: null,
      idPedido: null,
      idVenda: null,
      idpedidoditemd: null,
      item: {
        idpedidoback: null,
        idcliente: null,
        idPedidoItem: null,
        idCorTamanhoFinal: null,
        codigoProduto: null,
        nomeProduto: null,
        unidade: null,
        marca: null,
        status: null,
        quantidade: 0,
        preco: 0,
        descontoPercent: 0,
        descontoValor: 0,
        precoMinimo: 0,
        estoque: 0,
        precoUltimaVenda: 0,
        observacao: null,
        atendido: 0,
        flagDiluicao: false,
        textoDiluicao: null,
        valorDiluido: null,
        flagSubstituicao: false,
        textoSubstituicao: null,
        ordem: null,
        precoOriginal: 0,
        precocombo: 0,
        promocombo: null,
        qtdecombo: 0,
        ctfqtdecomboleva: 0,
      },
      desabilitarPreco: false,     
      desabilitarDesconto: false,  
      precoMinimoVisivel: false,
      quantidadeEstoqueVisivel: false,
      precoUltimaVendaVisivel: false,
      textoPromocao: null,
      dialogCancelar: false,
      dialogExcluir: false,
      dialogValidacao: false,
      exibirDiluicao: false,
      exibirSubstituicao: false,
      rendimentoLitros: 0,
      diluicaoProduto: null, 
      diluicaoAgua: null,
      mensagensErro: [],
      
      dadosEmpresa: null,
      dialogConfirmacaoEstoque: false,
      dialogBloqueioEstoque: false,
      quantidadeConfirmada: null,
      salvandoAposConfirmacao: false,
      confirmadoEstoqueZeradoNaGravacao: false,

      isCalculating: false,
    };
  },

  computed: {
    produtosOrdenadosPorCodigo() {
      return [...this.produtosEncontrados].sort((a, b) => {
        const codA = String(a.codigoExibicao || '');
        const codB = String(b.codigoExibicao || '');
        return codA.localeCompare(codB, undefined, { numeric: true });
      });
    },
    produtosOrdenadosPorNome() {
      return [...this.produtosEncontrados].sort((a, b) => {
        const descA = String(a.descricao || '');
        const descB = String(b.descricao || '');
        return descA.localeCompare(descB);
      });
    },
    isBloqueado() {
      return this.item.atendido === 1 && (this.item.idpedidoback !== null && this.item.idpedidoback !== undefined && this.item.idpedidoback !== '');
    },
    isItemInativo() {
      return this.isStatusInativo(this.item.status);
    },
    valorDiluidoFormatado: {
      get() {
        const valor = parseFloat(this.item.valorDiluido) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        const valorReal = (parseFloat(apenasNumeros) / 100) || 0;
        this.item.valorDiluido = valorReal;
      }
    },
    precoLiquido() {
      const preco = parseFloat(this.item.preco) || 0;
      const descValor = parseFloat(this.item.descontoValor) || 0;
      const liquido = preco - descValor;
      return liquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    totalItem() {
      const quantidade = parseFloat(this.item.quantidade) || 0;
      const preco = parseFloat(this.item.preco) || 0;
      const descValor = parseFloat(this.item.descontoValor) || 0;
      const liquido = preco - descValor;
      const total = liquido * quantidade;
      return total.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    precoFormatado: {
      get() {
        const valor = parseFloat(this.item.preco) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        const valorReal = (parseFloat(apenasNumeros) / 100) || 0;
        this.item.preco = valorReal;
      }
    },   
    precoMinimoFormatado() {
      const valor = parseFloat(this.item.precoMinimo) || 0;
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }, 
    quantidadeEstoqueFormatada() {
      const valor = parseFloat(this.item.estoque) || 0;
      return valor.toLocaleString('pt-BR');
    },
    mensagemBloqueioEstoque() {
      const estoque = parseFloat(this.item.estoque) || 0;
      if (estoque <= 0) {
        return 'O produto está com o estoque zerado (ou negativo) e a empresa não permite a venda de produtos sem estoque.';
      }
      return `A quantidade informada (${this.item.quantidade}) é maior que o estoque disponível (${this.quantidadeEstoqueFormatada}) e a empresa não permite a venda com estoque insuficiente.`;
    },
    precoUltimaVendaFormatado() {
      const valor = parseFloat(this.item.precoUltimaVenda) || 0;
      return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    descontoValorFormatado: {
      get() {
        const valor = parseFloat(this.item.descontoValor) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        const valorReal = (parseFloat(apenasNumeros) / 100) || 0;
        this.item.descontoValor = valorReal;
      }
    },
    descontoPercentFormatado: {
      get() {
        const valor = parseFloat(this.item.descontoPercent) || 0;
        return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      },
      set(novoValor) {
        const apenasNumeros = novoValor.toString().replace(/\D/g, '');
        const valorReal = (parseFloat(apenasNumeros) / 100) || 0;
        this.item.descontoPercent = valorReal;
      }
    }
  },

  watch: {
    searchCodigo(val) {
      const valStr = val !== null && val !== undefined ? String(val) : "";

      if (valStr) {
        const valorLimpo = valStr.replace(/\D/g, '');
        if (valStr !== valorLimpo) {
          this.$nextTick(() => { this.searchCodigo = valorLimpo; });
          return; 
        }
      }

      if (!valStr) {
        this.buscarNoDexie('', 'codigo');
      } else if (!this.produtoSelecionado || valStr !== String(this.produtoSelecionado.idcortamanhofinal || this.produtoSelecionado.idCortamanhofinal)) {
        this.buscarNoDexie(valStr, 'codigo');
      }
    },
    searchNome(val) {
      if (!val) {
        this.buscarNoDexie('', 'nome');
      } else if (!this.produtoSelecionado || val !== this.produtoSelecionado.descricao) {
        this.buscarNoDexie(val, 'nome');
      }
    },
    produtoSelecionado(newVal) {
      if (newVal) {
        const idParaBusca = newVal.idcortamanhofinal || newVal.idCortamanhofinal;
        this.buscarProduto(idParaBusca, true);
      } else {
        this.item.codigoProduto = null;
        this.item.nomeProduto = null;
        this.item.idCorTamanhoFinal = null;
        this.item.status = null;
        this.item.preco = 0;
        this.item.unidade = null;
        this.item.marca = null;
        this.item.promocombo = null;
        this.item.qtdecombo = 0;
        this.produtosEncontrados = [];
      }
    },
    'item.quantidade'(newVal) {
      this.aplicarRegrasPromocao(newVal);
    },
    'item.descontoPercent'(newVal) {
      if (this.isCalculating) return;
      this.isCalculating = true;

      const preco = parseFloat(this.item.preco) || 0;
      const perc = parseFloat(newVal) || 0;
      this.item.descontoValor = (preco * (perc / 100)).toFixed(2);
      
      this.$nextTick(() => { this.isCalculating = false; });
    },
    'item.descontoValor'(newVal) {
      if (this.isCalculating) return;
      this.isCalculating = true;

      const preco = parseFloat(this.item.preco) || 0;
      const valor = parseFloat(newVal) || 0;
      
      if (preco > 0) {
        this.item.descontoPercent = ((valor / preco) * 100).toFixed(2);
      } else {
        this.item.descontoPercent = 0;
      }
      
      this.$nextTick(() => { this.isCalculating = false; });
    },
  },

  methods: {
    aplicarRegrasPromocao(qtd) {
      const quantidade = parseFloat(qtd) || 0;
      if (this.item.promocombo === 'C' && this.item.precocombo > 0 && this.item.qtdecombo > 0) {
        if (quantidade >= this.item.qtdecombo) {
          this.item.preco = this.item.precocombo;
        } else {
          if (this.item.precoOriginal > 0) {
            this.item.preco = this.item.precoOriginal;
          }
        }
      } else if (this.item.promocombo === 'L' && this.item.qtdecombo > 0 && this.item.ctfqtdecomboleva > 0) {
        if (quantidade >= this.item.qtdecombo) {
          const qntdGrupos = Math.floor(quantidade / this.item.qtdecombo);
          const qntdRestante = quantidade % this.item.qtdecombo;
          const qntdPaga = (qntdGrupos * this.item.ctfqtdecomboleva) + qntdRestante;
          
          const totalComDesconto = qntdPaga * this.item.precoOriginal;
          this.item.preco = totalComDesconto / quantidade;
        } else {
          if (this.item.precoOriginal > 0) {
            this.item.preco = this.item.precoOriginal;
          }
        }
      }
    },

    somenteNumeros(event) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    }
  },

  filtrarColar(event) {
    const clipboardData = event.clipboardData || window.clipboardData;
    const pastedData = clipboardData.getData('Text');
    
    if (/\D/.test(pastedData)) {
      event.preventDefault();
    }
  },

    isStatusInativo(status) {
      if (status === null || status === undefined || status === '') return false;
      const st = String(status).trim().toUpperCase();
      return st === 'I' || st === 'INATIVO' || (st !== 'A' && st !== 'ATIVO');
    },

    async obterProdutoDexie(codigo, porId = false) {
      if (!codigo) return null;
      try {
        const idNum = !isNaN(Number(codigo)) ? Number(codigo) : codigo;
        const idStr = String(codigo).trim();

        if (porId) {
          let prod = await db.produto.where('idcortamanhofinal').equals(codigo).first();
          if (!prod && idNum !== codigo) prod = await db.produto.where('idcortamanhofinal').equals(idNum).first();
          if (!prod) prod = await db.produto.where('idcortamanhofinal').equals(idStr).first();
          if (!prod && db.produto.get) {
            prod = await db.produto.get(idNum) || await db.produto.get(idStr);
          }
          return prod;
        } else {
          let prod = await db.produto.where('codigointerno').equals(codigo).first();
          if (!prod && idNum !== codigo) prod = await db.produto.where('codigointerno').equals(idNum).first();
          if (!prod) prod = await db.produto.where('codigointerno').equals(idStr).first();
          return prod;
        }
      } catch (e) {
        console.error("Erro ao obter produto no Dexie:", e);
        return null;
      }
    },

    buscarNoDexie(termo, tipo) {
      clearTimeout(this.timerBusca);
      this.timerBusca = setTimeout(async () => {
        this.loadingBusca = true;
        
        try {
          let resultados = [];
          
          if (!termo) {
            resultados = await db.produto
              .filter(p => {
                const st = p.status || p.Status || p.STATUS;
                return !this.isStatusInativo(st);
              })
              .limit(10)
              .toArray();
          } else {
            const queryTerm = termo.toLowerCase();
            
            if (tipo === 'codigo') {
              resultados = await db.produto
                .filter(p => {
                  const st = p.status || p.Status || p.STATUS;
                  if (this.isStatusInativo(st)) return false;
                  const cod = String(p.idcortamanhofinal || p.idCortamanhofinal || '');
                  const codInterno = String(p.codigointerno || p.codigoInterno || '');
                  return cod.toLowerCase().includes(queryTerm) || codInterno.toLowerCase().includes(queryTerm);
                })
                .limit(30)
                .toArray();
            } else {
              resultados = await db.produto
                .filter(p => {
                  const st = p.status || p.Status || p.STATUS;
                  if (this.isStatusInativo(st)) return false;
                  const desc = String(p.descricao || '');
                  return desc.toLowerCase().includes(queryTerm);
                })
                .limit(30)
                .toArray();
            }
          }

          this.produtosEncontrados = resultados.map(p => ({
            ...p,
            codigoExibicao: String(p.idcortamanhofinal || p.idCortamanhofinal || '')
          }));

          if (tipo === 'codigo') {
            this.produtosEncontrados.sort((a, b) => {
              const codA = a.codigoExibicao || '';
              const codB = b.codigoExibicao || '';
              return codA.localeCompare(codB, undefined, { numeric: true }); 
            });
          } else {
            this.produtosEncontrados.sort((a, b) => {
              const descA = a.descricao || '';
              const descB = b.descricao || '';
              return descA.localeCompare(descB);
            });
          }

          if (this.produtoSelecionado) {
            const st = this.produtoSelecionado.status || this.produtoSelecionado.Status || this.produtoSelecionado.STATUS;
            if (!this.isStatusInativo(st)) {
              const idSelecionado = String(this.produtoSelecionado.idcortamanhofinal || this.produtoSelecionado.idCortamanhofinal);
              
              const jaExiste = this.produtosEncontrados.some(p => String(p.idcortamanhofinal || p.idCortamanhofinal) === idSelecionado);

              if (!jaExiste) {
                this.produtosEncontrados.push(this.produtoSelecionado);
              }
            }
          }

        } catch (error) {
          console.error("Erro na busca do Dexie:", error);
        } finally {
          this.loadingBusca = false;
        }
      }, 400);
    },

    focarProximo(refName) {
      this.$nextTick(() => {
        if (this.$refs[refName]) {
          this.$refs[refName].focus();
        }
      });
    },
    
    async salvar() {
      this.mensagensErro = [];

      if (!this.idPedido && this.$route.query.idPedido) {
        this.idPedido = parseInt(this.$route.query.idPedido, 10);
      }
        
      const qtd = parseFloat(this.item.quantidade);
      const preco = parseFloat(this.item.preco);
      const precoMin = parseFloat(this.item.precoMinimo);
      const descValor = parseFloat(this.item.descontoValor) || 0;
      const liq = preco - descValor;

      if (!this.item.idCorTamanhoFinal) {
        this.mensagensErro.push("Produto não identificado. Verifique o código.");
      } else {
        let statusProd = this.item.status;
        const prod = await this.obterProdutoDexie(this.item.idCorTamanhoFinal, true);
        if (prod) {
          statusProd = prod.status || prod.Status || prod.STATUS;
          this.item.status = statusProd;
        }

        if (this.isStatusInativo(statusProd)) {
          this.limparDadosItem();
          this.mensagensErro.push("Não é possível salvar o item porque está inativo.");
        }
      }

      if (isNaN(qtd) || qtd <= 0) {
        this.mensagensErro.push("A quantidade deve ser maior que zero.");
      }
      
      if (isNaN(preco) || preco <= 0) this.mensagensErro.push("O valor unitário deve ser maior que zero.");
      if (liq < precoMin) this.mensagensErro.push(`O preço líquido (R$ ${liq.toFixed(2)}) está abaixo do mínimo (R$ ${precoMin.toFixed(2)}).`);

      if (this.mensagensErro.length > 0) {
        this.dialogValidacao = true;
        return;
      }

      // Validação de estoque e parâmetros da empresa
      if (!this.dadosEmpresa) {
        await this.carregarDadosEmpresa();
      }

      const estoque = parseFloat(this.item.estoque) || 0;
      const vendaProdutoZerado = this.isParametroAtivo('vendaprodutozerado');
      const confirmaVendaZerado = this.isParametroAtivo('confirmavendaprodutozerado');

      if (estoque <= 0) {
        if (!vendaProdutoZerado) {
          this.dialogBloqueioEstoque = true;
          return;
        }

        if (confirmaVendaZerado && !this.confirmadoEstoqueZeradoNaGravacao) {
          this.salvandoAposConfirmacao = true;
          this.dialogConfirmacaoEstoque = true;
          return;
        }
      } else if (qtd > estoque) {
        if (!vendaProdutoZerado) {
          this.dialogBloqueioEstoque = true;
          return;
        }

        if (confirmaVendaZerado && this.quantidadeConfirmada !== qtd) {
          this.salvandoAposConfirmacao = true;
          this.dialogConfirmacaoEstoque = true;
          return;
        }
      }

      await this.executarPersistenciaItem(qtd, preco);
    },

    async executarPersistenciaItem(qtd, preco) {
      if (!this.idpedidoditemd) {
        this.idpedidoditemd = this.gerarUUID();
      }

      const tabela = db.pedidoitem || db.pedidoItem; 
      let ordemAtual = this.item.ordem;

      if (!this.itemDexieId) {
        try {
          const itensDestePedido = await tabela
            .where('idpedidoditemd')
            .equals(this.idpedidoditemd)
            .toArray();

          const maxOrdem = itensDestePedido.reduce((max, i) => Math.max(max, i.ordem || 0), 0);
          ordemAtual = maxOrdem + 1;
        } catch (e) {
          console.error("Erro ao calcular ordem sequencial:", e);
          ordemAtual = 1;
        }
      }

      const itemData = {
        idproduto: this.item.idProduto,
        ordem: ordemAtual,
        idcortamanhofinal: this.item.idCorTamanhoFinal,
        descricao: this.item.nomeProduto,
        observacao: this.item.observacao,
        quantidade: qtd,
        idcliente: this.item.idcliente,
        valordesconto: parseFloat(this.item.descontoValor) || 0,
        percdesconto: parseFloat(this.item.descontoPercent) || 0,
        valorunitario: preco,
        atendido: this.item.atendido,
        idpedido: this.idPedido ? parseInt(this.idPedido, 10) : null,
        idpedidoditemd: this.idpedidoditemd,
        UN: this.item.unidade,
        marca: this.item.marca,
        flagdiluicao: this.item.textoDiluicao ? 1 : 0,
        textodiluicao: this.item.textoDiluicao || null,
        valordiluido: parseFloat(this.item.valorDiluido) || null,
        flagsubstituicao: this.item.textoSubstituicao ? 1 : 0,
        textosubstituicao: this.item.textoSubstituicao
      };

      try {
        if (this.itemDexieId) {
          await tabela.update(this.itemDexieId, itemData);
        } else {
          const novoId = await tabela.add(itemData);
          await tabela.update(novoId, { idpedidoitem: novoId }); 
        }

        sessionStorage.setItem('idPedidoVinculoAtual', this.idpedidoditemd);
        sessionStorage.removeItem('itemPedidoEmEdicao');
        
        if (this.idPedido) sessionStorage.setItem('retornoIdPedido', this.idPedido);
        if (this.idVenda) sessionStorage.setItem('retornoIdVenda', this.idVenda);
        if (this.item.idCorTamanhoFinal) sessionStorage.setItem('retornoIdCorTamanhoFinal', this.item.idCorTamanhoFinal);
        if (this.item.idcliente) sessionStorage.setItem('retornoIdCliente', this.item.idcliente);

        this.$router.back();
        
      } catch (error) {
        console.error("Erro ao salvar item:", error);
      }
    },

    async aoAlterarQuantidade() {
      if (!this.dadosEmpresa) {
        await this.carregarDadosEmpresa();
      }

      const estoque = parseFloat(this.item.estoque) || 0;
      const qtd = parseFloat(this.item.quantidade) || 0;

      if (estoque > 0 && qtd > estoque) {
        const vendaProdutoZerado = this.isParametroAtivo('vendaprodutozerado');
        const confirmaVendaZerado = this.isParametroAtivo('confirmavendaprodutozerado');

        if (!vendaProdutoZerado) {
          this.dialogBloqueioEstoque = true;
          return;
        }

        if (confirmaVendaZerado && this.quantidadeConfirmada !== qtd) {
          this.dialogConfirmacaoEstoque = true;
          return;
        }
      }
    },

    confirmarEstoque() {
      this.dialogConfirmacaoEstoque = false;
      const qtd = parseFloat(this.item.quantidade) || 0;
      this.quantidadeConfirmada = qtd;
      this.confirmadoEstoqueZeradoNaGravacao = true;

      if (this.salvandoAposConfirmacao) {
        this.salvandoAposConfirmacao = false;
        this.salvar();
      }
    },

    cancelarConfirmacaoEstoque() {
      this.dialogConfirmacaoEstoque = false;
      this.quantidadeConfirmada = null;
      this.confirmadoEstoqueZeradoNaGravacao = false;
      this.salvandoAposConfirmacao = false;
      this.$nextTick(() => {
        if (this.$refs.quantidadeInput) {
          this.$refs.quantidadeInput.focus();
        }
      });
    },

    fecharDialogBloqueio() {
      this.dialogBloqueioEstoque = false;
      this.confirmadoEstoqueZeradoNaGravacao = false;
      this.salvandoAposConfirmacao = false;
      this.$nextTick(() => {
        if (this.$refs.quantidadeInput) {
          this.$refs.quantidadeInput.focus();
        }
      });
    },

    async carregarDadosEmpresa() {
      try {
        const registro = await db.empresa.limit(1).first();
        this.dadosEmpresa = registro || {};
      } catch (e) {
        console.error("Erro ao carregar dados da empresa:", e);
        this.dadosEmpresa = {};
      }
    },

    isParametroAtivo(nome) {
      if (!this.dadosEmpresa) return false;
      let valor = this.dadosEmpresa[nome];
      if (valor === undefined) {
        const lower = nome.toLowerCase();
        for (const key of Object.keys(this.dadosEmpresa)) {
          if (key.toLowerCase() === lower) {
            valor = this.dadosEmpresa[key];
            break;
          }
        }
      }
      if (typeof valor === 'string') {
        return valor.trim().toUpperCase() === 'S';
      }
      if (typeof valor === 'boolean') {
        return valor === true;
      }
      if (typeof valor === 'number') {
        return valor === 1;
      }
      return false;
    },

    gerarUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },

    async verificarRetornoPesquisa() {
      const resultadoPesquisa = sessionStorage.getItem('pesquisaResultado');
      
      if (resultadoPesquisa) {
        try {
          const data = JSON.parse(resultadoPesquisa);
          sessionStorage.removeItem('pesquisaResultado');

          if (data.tipo === 'Produto') {
            if (data.id) {
              await this.buscarProduto(data.id, true); 
            } 
            else if (data.codigo) {
              await this.buscarProduto(data.codigo, false);
            }

            if (data.promoAplicada) {
              this.item.precoOriginal = data.precoOriginal || data.preco;
              this.item.precocombo = data.precocombo || 0;
              this.item.promocombo = data.promocombo || null;
              this.item.qtdecombo = data.qtdecombo || 0;
              this.item.ctfqtdecomboleva = data.ctfqtdecomboleva || 0;

              if (this.item.promocombo === 'C' || this.item.promocombo === 'L') {
                this.aplicarRegrasPromocao(this.item.quantidade);
              } else {
                this.item.preco = data.preco;
              }
              this.desabilitarDesconto = true;
              this.item.descontoPercent = 0;
              this.item.descontoValor = 0;
            }
          }
        } catch (e) {
          console.error("Erro ao processar retorno da pesquisa:", e);
        }
      }
    },
    cancelar() {
      if (this.item.atendido === 1) {
        this.confirmarCancelamento();
        return;
      }
      const temDadosPreenchidos = 
        this.item.codigoProduto || 
        this.item.idCorTamanhoFinal || 
        (this.item.observacao && this.item.observacao.trim() !== '') ||
        (this.item.preco && parseFloat(this.item.preco) > 0);
      if (temDadosPreenchidos) {
        this.dialogCancelar = true;
      } else {
        this.confirmarCancelamento();
      }
    },

    confirmarCancelamento() {
      sessionStorage.removeItem('itemPedidoEmEdicao'); 
      this.dialogCancelar = false;
      this.$router.back();
    },

    excluir() {
      this.dialogExcluir = true;
    },

    async confirmarExclusao() {
      this.dialogExcluir = false;
      if (!this.itemDexieId) {
        alert("Erro: ID do item não encontrado para exclusão.");
        return;
      }

      const tabela = db.pedidoitem; 
      await tabela.delete(this.itemDexieId);
      sessionStorage.removeItem('itemPedidoEmEdicao');
      
      const salvosLaranja = sessionStorage.getItem('itensVisuaisLaranja');
      
      if (salvosLaranja) { 
        let acumulado = JSON.parse(salvosLaranja);
        const idProd = String(this.item.idCorTamanhoFinal);
        
        acumulado = acumulado.filter(itemSalvo => {
          const stringSalva = String(itemSalvo);
          return stringSalva !== idProd && !stringSalva.endsWith(`-${idProd}`);
        });
        
        if (acumulado.length === 0) {
          sessionStorage.removeItem('itensVisuaisLaranja');
        } else {
          sessionStorage.setItem('itensVisuaisLaranja', JSON.stringify(acumulado));
        }
      }

      this.$router.back();
    },

    pesquisarProduto() {
      if (this.$route.query.origem === 'produto') {
        this.salvarEstadoTemporario();
        this.$router.back();
        return;
      }

      this.salvarEstadoTemporario();
      const idCliente = this.item.idcliente || this.$route.query.idcliente;
      const nomeCliente = this.$route.query.nomecliente || '';

      this.$router.push({ 
        path: '/cadastro-pedido-produto',
        query: {
          idpedido: this.idPedido,
          idcliente: idCliente,
          nomecliente: nomeCliente,
        }
      });
    },

    async carregarItem(id) {
      try {
        const tabela = db.pedidoitem || db.pedidoItem;
        const item = await tabela.get(id);
        
        if (item) {
          this.idPedido = item.idpedido || item.idPedido || this.idPedido;
          this.idpedidoditemd = item.idpedidoditemd;
          this.item.idPedidoItem = item.idpedidoitem || item.idPedidoItem;
          this.item.idCorTamanhoFinal = item.idcortamanhofinal || item.idCorTamanhoFinal;
          this.item.quantidade = item.quantidade;
          this.item.preco = item.valorunitario || item.valorUnitario;
          this.item.descontoValor = item.valordesconto || item.valorDesconto;
          this.item.descontoPercent = item.percdesconto || item.percDesconto;
          this.item.observacao = item.observacao;
          this.item.atendido = item.atendido;
          this.item.idpedidoback = item.idpedidoback || item.idPedidoBack || null;

          this.item.flagDiluicao = item.flagdiluicao === 1 || item.flagDiluicao === 1 || item.flagdiluicao === true;
          this.item.textoDiluicao = item.textodiluicao || item.textoDiluicao;
          this.item.valorDiluido = item.valordiluido || item.valorDiluido || null;
          this.item.flagSubstituicao = item.flagsubstituicao === 1 || item.flagSubstituicao === 1 || item.flagsubstituicao === true;
          this.item.textoSubstituicao = item.textosubstituicao || item.textoSubstituicao;
          this.item.ordem = item.ordem || null;
          
          if (this.isBloqueado) { 
            this.desabilitarPreco = true;
            this.desabilitarDesconto = true;
          }
          
          if (this.item.idCorTamanhoFinal) {
            await this.buscarProduto(this.item.idCorTamanhoFinal, true);
          }
        }
      } catch (error) {
        console.error("Erro ao carregar item:", error);
      }
    },

    salvarEstadoTemporario() {
      const estado = {
        item: this.item,
        idPedido: this.idPedido,
        itemDexieId: this.itemDexieId,
        idpedidoditemd: this.idpedidoditemd,
        precoMinimoVisivel: this.precoMinimoVisivel,
        quantidadeEstoqueVisivel: this.quantidadeEstoqueVisivel,
        exibirDiluicao: this.exibirDiluicao,
        exibirSubstituicao: this.exibirSubstituicao
      };
      sessionStorage.setItem('itemPedidoEmEdicao', JSON.stringify(estado));
    },

    limparDadosItem() {
      this.produtoSelecionado = null;
      this.searchCodigo = "";
      this.searchNome = "";
      this.produtosEncontrados = [];

      this.item.idCorTamanhoFinal = null;
      this.item.codigoProduto = null;
      this.item.nomeProduto = null;
      this.item.unidade = null;
      this.item.marca = null;
      this.item.status = null;
      this.item.quantidade = 0;
      this.item.preco = 0;
      this.item.precoOriginal = 0;
      this.item.precoMinimo = 0;
      this.item.estoque = 0;
      this.item.descontoValor = 0;
      this.item.descontoPercent = 0;
      this.item.promocombo = null;
      this.item.precocombo = 0;
      this.item.qtdecombo = 0;
      this.item.ctfqtdecomboleva = 0;
      this.item.textoDiluicao = null;
      this.item.valorDiluido = null;
      this.item.flagDiluicao = false;
      this.item.textoSubstituicao = null;
      this.item.flagSubstituicao = false;
      this.exibirDiluicao = false;
      this.exibirSubstituicao = false;
      this.textoPromocao = null;
      this.desabilitarPreco = false;
      this.desabilitarDesconto = false;
    },

    async verificarCodigoDigitado() {
      if (!this.searchCodigo) return;
      const codigoLimpo = String(this.searchCodigo).trim();
      const prod = await this.obterProdutoDexie(codigoLimpo, true)
        || await this.obterProdutoDexie(codigoLimpo, false);
      if (prod) {
        const st = prod.status || prod.Status || prod.STATUS;
        if (this.isStatusInativo(st)) {
          this.limparDadosItem();
          this.mensagensErro = [];
          this.mensagensErro.push("Não é possível salvar o item porque está inativo.");
          this.dialogValidacao = true;
          return;
        }
        this.produtoSelecionado = prod;
      }
    },

    async buscarProduto(codigo, porId = false) {
      if (!codigo) return;
      
      let produto = null;
      try {
        produto = await this.obterProdutoDexie(codigo, porId);

        if (produto) {
          const statusProduto = produto.status || produto.Status || produto.STATUS;
          if (this.isStatusInativo(statusProduto)) {
            this.limparDadosItem();
            this.mensagensErro = [];
            this.mensagensErro.push("Não é possível salvar o item porque está inativo.");
            this.dialogValidacao = true;
            return;
          }

          const novoIdCorTamanhoFinal = produto.idcortamanhofinal || produto.idCortamanhofinal;
          
          produto.codigoExibicao = String(novoIdCorTamanhoFinal || '');

          if (!this.produtoSelecionado || (this.produtoSelecionado.idcortamanhofinal || this.produtoSelecionado.idCortamanhofinal) !== novoIdCorTamanhoFinal) {
            this.produtosEncontrados = [produto];
            this.produtoSelecionado = produto;
          }

          const produtoMudou = this.item.idCorTamanhoFinal !== novoIdCorTamanhoFinal;

          this.item.idCorTamanhoFinal = novoIdCorTamanhoFinal;
          this.item.status = produto.status || produto.Status || produto.STATUS || null;
          
          const isGrupo1 = (Number(produto.idgrupo) === 1 || Number(produto.idGrupo) === 1);
          this.exibirDiluicao = isGrupo1;
          this.exibirSubstituicao = isGrupo1;

          if (!isGrupo1) {
            this.item.textoDiluicao = null;
            this.item.textoSubstituicao = null;
            this.item.rendimentoLitros = 0; 
          } else {
            this.item.rendimentoLitros = parseFloat(produto.rendimentolitros || produto.rendimentoLitros) || 0;
          }
          this.item.codigoProduto = produto.codigointerno || produto.codigoInterno;
          this.item.nomeProduto = produto.descricao;
          this.item.marca = produto.marca;
          this.item.unidade = produto.un || produto.um;
          
          const precoBanco = produto.preco;
          
          if (this.item.preco === 0 || (!porId && produtoMudou)) {
            this.item.preco = precoBanco;
            this.item.descontoValor = 0;
            this.item.descontoPercent = 0;
          }
          
          this.item.precoMinimo = produto.precominico || produto.precoMinimo;
          this.item.estoque = produto.estoque || 0;
          await this.buscarPrecoUltimaVenda();
          
          this.desabilitarPreco = false;
          this.desabilitarDesconto = false;
          this.textoPromocao = null;

          const pedePreco = produto.pedepreco || produto.pedePreco;
          if (pedePreco === 'N') {
            this.desabilitarPreco = true;
          }

          const promo = produto.promocombo || produto.promocaocombo || produto.promocaoCombo;
          
          if (promo && promo !== 'null' && promo !== 'N') {
            this.desabilitarDesconto = true;
            this.item.descontoPercent = 0;
            this.item.descontoValor = 0;

            const qtdeCombo = Math.round(produto.qtdecombo || produto.QtdeCombo || 0);
            const leva = Math.round(produto.ctfqtdecomboleva || produto.CTFQtdeComboLeva || 0);
            const precoCombo = parseFloat(produto.precocombo || produto.PrecoCombo || 0);

            this.item.promocombo = promo;
            this.item.qtdecombo = qtdeCombo;
            this.item.ctfqtdecomboleva = leva;
            this.item.precocombo = precoCombo;
            this.item.precoOriginal = precoBanco;

            if (promo === 'F' && precoCombo > 0) {
              this.item.preco = precoCombo;
              this.item.precoMinimo = precoCombo;
            } else if (promo === 'C' && precoCombo > 0) {
              this.item.precoMinimo = precoCombo;
              this.aplicarRegrasPromocao(this.item.quantidade);
            } else if (promo === 'L') {
              this.aplicarRegrasPromocao(this.item.quantidade);
            }

            switch (promo) {
              case 'L':
                this.desabilitarPreco = true; 
                this.textoPromocao = `Levando: ${qtdeCombo} un. Pague apenas: ${leva} un.`;
                break;
              case 'F':
                this.textoPromocao = `Preço Oferta: R$ ${precoCombo.toFixed(2).replace('.', ',')}.`;
                break;
              case 'C':
                this.desabilitarPreco = true; 
                this.textoPromocao = `Levando: ${qtdeCombo} un. Preço por unidade: R$ ${precoCombo.toFixed(2).replace('.', ',')}.`;
                break;
            }
          }
          
          this.$nextTick(() => {
            if (this.$refs.quantidadeInput) {
              this.$refs.quantidadeInput.focus();
            }
          });

        } else {
          this.item.nomeProduto = "Produto não encontrado";
          this.item.status = null;
          this.item.precoUltimaVenda = 0;
          this.exibirDiluicao = false;
          this.exibirSubstituicao = false;
          this.textoPromocao = null;
        }
      } catch (error) {
        console.error("Erro ao buscar produto:", error);
      }
    },

    async buscarPrecoUltimaVenda() {
      try {
        const idProduto = parseInt(this.item.idCorTamanhoFinal, 10);
        if (!idProduto) {
          this.item.precoUltimaVenda = 0;
          return;
        }

        let idCliente = this.item.idcliente;
        if (!idCliente) {
          const idCliUrl = this.$route.query.idcliente || this.$route.query.idCliente;
          if (idCliUrl) {
            idCliente = parseInt(idCliUrl, 10);
            this.item.idcliente = idCliente;
          }
        }
        if (!idCliente) {
          const idCliSessao = sessionStorage.getItem('retornoIdCliente');
          if (idCliSessao && idCliSessao !== 'null' && idCliSessao !== 'undefined') {
            idCliente = parseInt(idCliSessao, 10);
            this.item.idcliente = idCliente;
          }
        }
        if (!idCliente && this.idPedido) {
          const ped = await db.pedido.get(parseInt(this.idPedido, 10));
          if (ped && ped.idcliente) {
            idCliente = parseInt(ped.idcliente, 10);
            this.item.idcliente = idCliente;
          }
        }
        if (!idCliente) {
          const pedidoEmEdicao = sessionStorage.getItem('pedidoEmEdicao');
          if (pedidoEmEdicao) {
            try {
              const parsed = JSON.parse(pedidoEmEdicao);
              const cli = parsed?.formData?.cliente || parsed?.cliente;
              if (cli) {
                idCliente = parseInt(cli, 10);
                this.item.idcliente = idCliente;
              }
            } catch (e) {
              console.warn("Erro ao buscar cliente do pedido em edição:", e);
            }
          }
        }

        if (!idCliente) {
          this.item.precoUltimaVenda = 0;
          return;
        }

        const idCliNum = parseInt(idCliente, 10);
        const candidatos = [];

        // 1. Histórico de vendas (db.venda)
        if (db.venda) {
          let vendas = await db.venda
            .where('idcliente')
            .equals(idCliNum)
            .filter(v => {
              if (v.cancelado === 'S' || v.cancelado === '1' || v.cancelado === true) return false;
              const vCtf = parseInt(v.idcortamanhofinal || v.IdCorTamanhoFinal || v.idCortamanhofinal || 0, 10);
              return vCtf === idProduto;
            })
            .toArray();

          if (!vendas.length) {
            vendas = await db.venda
              .where('idcliente')
              .equals(String(idCliNum))
              .filter(v => {
                if (v.cancelado === 'S' || v.cancelado === '1' || v.cancelado === true) return false;
                const vCtf = parseInt(v.idcortamanhofinal || v.IdCorTamanhoFinal || v.idCortamanhofinal || 0, 10);
                return vCtf === idProduto;
              })
              .toArray();
          }

          vendas.forEach(v => {
            let precoUnit = 0;
            if (v.valorunitario !== undefined && v.valorunitario !== null && parseFloat(v.valorunitario) > 0) {
              precoUnit = parseFloat(v.valorunitario);
            } else if (v.vlrunitario !== undefined && v.vlrunitario !== null && parseFloat(v.vlrunitario) > 0) {
              precoUnit = parseFloat(v.vlrunitario);
            } else if (v.valorUnitario !== undefined && v.valorUnitario !== null && parseFloat(v.valorUnitario) > 0) {
              precoUnit = parseFloat(v.valorUnitario);
            } else if (v.preco !== undefined && v.preco !== null && parseFloat(v.preco) > 0) {
              precoUnit = parseFloat(v.preco);
            } else {
              const valor = parseFloat(v.valor || v.Valor || 0);
              const qtde = parseFloat(v.qtde || v.Qtde || 1);
              precoUnit = qtde > 0 ? (valor / qtde) : valor;
            }

            if (precoUnit > 0) {
              candidatos.push({
                data: v.data || v.Data || v.datavenda || 0,
                preco: precoUnit
              });
            }
          });
        }

        // 2. Pedidos no Dexie (db.pedido + db.pedidoitem)
        if (db.pedido && db.pedidoitem) {
          let pedidos = await db.pedido
            .where('idcliente')
            .equals(idCliNum)
            .filter(p => !p.datacancelamento && p.datacancelamento !== 'S')
            .toArray();

          if (!pedidos.length) {
            pedidos = await db.pedido
              .where('idcliente')
              .equals(String(idCliNum))
              .filter(p => !p.datacancelamento && p.datacancelamento !== 'S')
              .toArray();
          }

          // Ignorar o pedido atual em edição, se houver
          if (this.idPedido) {
            const idPedAtual = parseInt(this.idPedido, 10);
            pedidos = pedidos.filter(p => {
              const idPed = parseInt(p.idpedido || p.id || 0, 10);
              const idBack = parseInt(p.idpedidoback || 0, 10);
              return idPed !== idPedAtual && idBack !== idPedAtual;
            });
          }

          if (pedidos.length > 0) {
            const mapaPedidos = new Map();
            pedidos.forEach(p => {
              const idPed = p.idpedido || p.id;
              if (idPed) mapaPedidos.set(idPed, p);
              if (p.idpedidoback) mapaPedidos.set(p.idpedidoback, p);
            });

            const idsPedidos = Array.from(mapaPedidos.keys());
            let itens = await db.pedidoitem
              .where('idcortamanhofinal')
              .equals(idProduto)
              .filter(i => {
                if (i.DT_Cancelado) return false;
                const idPed = i.idpedido || i.idpedidoback;
                return idsPedidos.includes(idPed);
              })
              .toArray();

            if (!itens.length) {
              itens = await db.pedidoitem
                .where('idcortamanhofinal')
                .equals(String(idProduto))
                .filter(i => {
                  if (i.DT_Cancelado) return false;
                  const idPed = i.idpedido || i.idpedidoback;
                  return idsPedidos.includes(idPed);
                })
                .toArray();
            }

            itens.forEach(item => {
              const ped = mapaPedidos.get(item.idpedido) || mapaPedidos.get(item.idpedidoback);
              const dataPed = ped ? (ped.data || ped.Data) : null;
              const precoUnit = parseFloat(item.valorunitario || item.valorUnitario || item.preco || 0);
              if (precoUnit > 0) {
                candidatos.push({
                  data: dataPed || 0,
                  preco: precoUnit
                });
              }
            });
          }
        }

        if (candidatos.length > 0) {
          candidatos.sort((a, b) => {
            const dataA = new Date(a.data || 0).getTime();
            const dataB = new Date(b.data || 0).getTime();
            return dataB - dataA;
          });
          this.item.precoUltimaVenda = candidatos[0].preco;
        } else {
          this.item.precoUltimaVenda = 0;
        }
      } catch (error) {
        console.error("Erro ao buscar preço da última venda:", error);
        this.item.precoUltimaVenda = 0;
      }
    },
  },

  async activated() {
    await this.verificarRetornoPesquisa();
  },

  async created() {
    window.scrollTo(0, 0);
    await this.carregarDadosEmpresa();

    const itensIniciais = await db.produto
      .filter(p => {
        const st = p.status || p.Status || p.STATUS;
        return !this.isStatusInativo(st);
      })
      .limit(10)
      .toArray();
    this.produtosEncontrados = itensIniciais.map(p => ({
      ...p,
      codigoExibicao: String(p.idcortamanhofinal || p.idCortamanhofinal || '')
    })).sort((a, b) => {
      const descA = a.descricao || '';
      const descB = b.descricao || '';
      return descA.localeCompare(descB);
    });

    const estadoSalvo = sessionStorage.getItem('itemPedidoEmEdicao');
    if (estadoSalvo) {
      const estado = JSON.parse(estadoSalvo);
      this.item = estado.item;
      this.idPedido = estado.idPedido;
      this.itemDexieId = estado.itemDexieId;
      this.idpedidoditemd = estado.idpedidoditemd;
      this.precoMinimoVisivel = estado.precoMinimoVisivel || false;
      this.quantidadeEstoqueVisivel = estado.quantidadeEstoqueVisivel || false;
      this.precoUltimaVendaVisivel = estado.precoUltimaVendaVisivel || false;
      this.exibirDiluicao = estado.exibirDiluicao || false;
      this.exibirSubstituicao = estado.exibirSubstituicao || false;
      sessionStorage.removeItem('itemPedidoEmEdicao');
    }

    const idUrl = this.$route.query.idPedido || this.$route.query.idpedido;
    if (idUrl) {
      this.idPedido = parseInt(idUrl, 10);
    } else {
      const idPedidoSessao = sessionStorage.getItem('retornoIdPedido');
      if (idPedidoSessao && idPedidoSessao !== 'null' && idPedidoSessao !== 'undefined') {
        this.idPedido = parseInt(idPedidoSessao, 10);
      }
    }

    const idVendaUrl = this.$route.query.idvenda;
    if (idVendaUrl) {
      this.idVenda = idVendaUrl;
    }

    const idClienteUrl = this.$route.query.idcliente;
    if (idClienteUrl) {
      this.item.idcliente = parseInt(idClienteUrl, 10);
    } else {
      const idCliSessao = sessionStorage.getItem('retornoIdCliente');
      if (idCliSessao && idCliSessao !== 'null' && idCliSessao !== 'undefined') {
        this.item.idcliente = parseInt(idCliSessao, 10);
      }
    }
    
    const itemId = this.$route.query.id ? parseInt(this.$route.query.id, 10) : null;
    const idVinculo = this.$route.query.idpedidoditemd;

    if (idVinculo) {
      this.idpedidoditemd = idVinculo;
    } else {
      const vinculoSessao = sessionStorage.getItem('idPedidoVinculoAtual');
      if (vinculoSessao && vinculoSessao !== 'null' && vinculoSessao !== 'undefined') {
        this.idpedidoditemd = vinculoSessao;
      }
    }

    if (itemId) {
      this.itemDexieId = itemId;
      await this.carregarItem(itemId);
    } else {
      this.item.quantidade = 0;
      if (!this.item.precoLiquido) this.item.preco = 0;

      const temPesquisa = !!sessionStorage.getItem('pesquisaResultado');
      const histIdProduto = this.$route.query.idproduto ? parseInt(this.$route.query.idproduto) : null;
      const histQtde = this.$route.query.qtde;
      const histIdCliente = this.$route.query.idcliente;

      if (histIdProduto && !temPesquisa) {
        await this.buscarProduto(histIdProduto, true);
        if (histQtde) {
          this.item.quantidade = parseFloat(histQtde);
        }
        if (histIdCliente) {
          this.item.idcliente = parseFloat(histIdCliente);
        }
      }
    }

    await this.verificarRetornoPesquisa();

    if (this.item.idCorTamanhoFinal && (!this.item.precoUltimaVenda || this.item.precoUltimaVenda === 0)) {
      await this.buscarPrecoUltimaVenda();
    }
  },
};
</script>

<style scoped>
.formulario-wrapper {
  padding: 32px 16px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.v-card {
  max-width: 900px;
  width: 100%;
}
.v-form .v-row {
  margin-bottom: 4px;
}

.v-input--is-readonly >>> .v-input__slot {
  background-color: #FFF9C4 !important; 
}
</style>  